import { Button, cn } from '@seen/ui'
import type { ReactNode } from 'react'

export function DisplayPropertyButton({
  isSelected,
  onClick,
  children,
}: {
  isSelected: boolean
  onClick: () => void
  children: ReactNode
}): ReactNode {
  return (
    <Button
      variant="outline"
      size="xs"
      className={cn(
        !isSelected &&
          'border-[lch(95.207_0_282.863)] text-foreground-secondary shadow-none'
      )}
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
    >
      {children}
    </Button>
  )
}
